import { render, staticRenderFns } from "./ContentViewSettingsCallout.vue?vue&type=template&id=15519569&scoped=true&"
import script from "./ContentViewSettingsCallout.vue?vue&type=script&lang=js&"
export * from "./ContentViewSettingsCallout.vue?vue&type=script&lang=js&"
import style0 from "./ContentViewSettingsCallout.vue?vue&type=style&index=0&id=15519569&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15519569",
  null
  
)

export default component.exports